import axios from 'axios';
import { settingsConfig } from 'configs/settingsConfig';

export const GET_CART_DATA = 'GET CART DATA';
export const SET_CART_DATA_LOADER = 'SET CART DATA LOADER';

export const UPDATE_CART_ITEM = 'UPDATE CART ITEM';
export const SET_UPDATE_CART_ITEM_LOADER = 'SET UPDATE CART ITEM LOADER';

export function getCartData() {
	const request = axios.get(settingsConfig.api_url + 'cart/list/');
	return (dispatch) =>
		request.then((response) => {
			dispatch({
				type: GET_CART_DATA,
				payload: response.data
			});
		});
}
export function setCartDataLoader(value) {
	return {
		type: SET_CART_DATA_LOADER,
		payload: value
	};
}

export function updateCartItem(data) {
	const request = axios.post(settingsConfig.api_url + 'cart/update/' + data.variantId + '/', {
		quantity: data.quantity
	});
	return (dispatch) =>
		request.then((response) => {
			dispatch({
				type: UPDATE_CART_ITEM,
				payload: response.data
			});
		});
}
export function setUpdateCartItemLoader(value) {
	return {
		type: SET_UPDATE_CART_ITEM_LOADER,
		payload: value
	};
}
